var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toolbar',{ref:"toolbar",staticClass:"repeatable-toolbar",attrs:{"hidden":!_vm.editor || !_vm.active,"position":_vm.position,"buttons":[
    [
      { icon: 'el-icon-fa-arrow-up', title: _vm.$t('Move Up'), click: function () { return _vm.editor.moveRepeatableUp(); } },
      { icon: 'el-icon-fa-arrow-down', title: _vm.$t('Move Down'), click: function () { return _vm.editor.moveRepeatableDown(); } },
      { icon: 'el-icon-fa-copy', title: _vm.$t('Duplicate'), click: function () { return _vm.editor.duplicateRepeatable(); } },
      { icon: 'el-icon-fa-trash', title: _vm.$t('Delete'), click: function () { return _vm.editor.deleteRepeatable(); } }
    ]
  ]}})}
var staticRenderFns = []

export { render, staticRenderFns }